import React, { Component, Fragment } from 'react';
import style from './style';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { hideModal } from './actions';

const classnames = classNames.bind(style);

@connect((state) => ({
    show: state.modal.show,
    src : state.modal.src
}))
class Modal extends Component { //eslint-disable-line react/prefer-stateless-function

    static displayName = '[block] modal';

    static propTypes = {
        show    : PropTypes.bool,
        dispatch: PropTypes.func,
        src     : PropTypes.string
    };

    hide = (e) => {
        e.preventDefault();
        this.props.dispatch(hideModal())
    };

    render() {
        return (
            <Fragment>
                <div
                    className={classnames('modal__overlay', {
                        modal__overlay_show: this.props.show //eslint-disable-line camelcase
                    })}
                    onClick={this.hide}
                />
                <div
                    className={classnames('modal__dialog', {
                        modal__dialog_show: this.props.show //eslint-disable-line camelcase
                    })}
                >
                    <div className={style['modal__content']}>
                        <div className={style['modal__header']}>
                            <button type="button" onClick={this.hide} className={style['modal__close']}>×</button>
                            <h3 className={style['modal__title']}>{this.props.src ? 'Предварительный просмотр' : 'Краткая инструкция по печатной линии'}</h3>
                        </div>
                        <div className={style['modal__body']}>
                            {this.props.src ? <iframe title="pdf" className={style['modal__pdf']} src={this.props.src} /> : // eslint-disable-line operator-linebreak
                                // eslint-disable-next-line react/jsx-indent
                                <div className={style['modal__scroll']}>
                                    <p>
                                        <strong>Логотип сети.</strong> Возможные враианты: Лига Ставок, Оскар Ярд Пушкинская, Оскар Ярд Рублёвка. В зависимости от выбранного значения меняется «шапка» сформированного документа: логотип для печати, телефоны, адреса клубов.
                                    </p>
                                    <p>
                                        <strong>Тип линии.</strong> В Основной росписи выводятся исходы и коэффициенты по основным типам ставок. Для Основной росписи возможен выбор ориентации старниц – горизонтальная (в сформированном pdf-файле  таблица результатов на странице делится на две колонки) и вертикальная (в сформированном pdf-файле  таблица результатов занимает всю ширину страницы).
                                        <br />В Полной росписи выводятся все исходы и коэффициенты, включенные в шаблоны.
                                        <strong>Важно: для формирования Полной линии установлен лимит – 500 событий!</strong>
                                    </p>
                                    <p>
                                        <strong>Период выборки</strong> – период времени, за которое будет сформирована линия. Можно выбрать значение из списка или задать интервал вручную с помощью календаря.
                                    </p>
                                    <p>
                                        <strong>Специальное</strong> – параметр, который позволяет сделать выборку по всем видам спорта, только по событиям, отмеченным группой аналитиков как популярные, либо воспользоваться поиском событий по их ID. Поиск позволяет составить список из нескольких событий.  События из списка можно удалять и добавлять новые. Заданный приод выборки не влияет на результаты поиска.
                                    </p>
                                    <p>
                                        Чтобы <strong>сформировать линию</strong>, нужно выбрать необходимые параметры, отметить чекбоксами нужные виды спорта или топики и нажать кнопку «Сформировать линию»
                                    </p>
                                    <p>
                                        В правой части экрана появляется блок с информацией о сформированной линии: Логотип сети, Тип линии, Период выборки, Специальное, а также кнопки «Предварительный просмотр» и «Скачать линию».
                                    </p>
                                    <p>
                                        Каждый новый блок добавляется в конец списка. Менять местами блоки нельзя . Для удаления блока  из списка нужно нажать на кнопку &quot;Удалить&quot; в виде крестика.
                                    </p>
                                    <p>
                                        Для <strong>предварительного просмотра документа</strong> нужно нажать одноименную кнопку. Для просмотра доступно не более пяти первых страниц документа.
                                    </p>
                                    <p>
                                        Чтобы <strong>загрузить сформированную линию на ПК</strong>,  нужно нажать кнопку «Скачать линию». Распечатать линию можно только после ее загрузки.
                                    </p>
                                    <p>
                                        <strong>Важно: при печати из окна предпросмотра буду распечатаны только видимые страницы, а не весь документ!</strong>
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

}

export default Modal;



// WEBPACK FOOTER //
// ./src/blocks/modal/index.js